/**
 * Links.
 */

const link_mods = (args) => {
    // setup args
    let links = args.links;

    // validate
    if (!links.length) {
        // console.log('Invalid args');
        return;
    }

    function add_aria_description(link, description) {
        let old_description = link.getAttribute('aria-description');
        // prettier-ignore
        link.setAttribute('aria-description', old_description ? old_description + ', ' + description : description);
    }

    function init() {
        links.forEach((link) => {
            // console.log('link', link);

            if (
                link.href.startsWith('sms:') ||
                link.href.startsWith('tel:') ||
                link.href.startsWith('mailto:') ||
                link.href.startsWith('javascript:') // jshint ignore:line
            ) {
                return;
            }

            // Links that open in a new tab
            if (link.target === '_blank') {
                link.classList.add('-opens-in-new-tab');
                add_aria_description(link, window.new_tab_description);
            }

            // External links
            if (link.hostname !== window.location.hostname) {
                link.classList.add('-external');
                add_aria_description(link, window.external_link_description);
            }
        });
    }

    init();

    // make the call chainable
    return this;
};

link_mods({
    links: document.querySelectorAll('a[href]'),
});
